import React from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

const GameTeeTime = ({ Timestamp, teeTime = null }) => {
  // Convert Firestore Timestamp to JavaScript Date if needed
  const getFormattedTime = () => {
    if (!teeTime) return 'Not set';

    try {
      // If teeTime is a Firestore Timestamp, convert it to Date
      if (teeTime && typeof teeTime.toDate === 'function') {
        return dayjs(teeTime.toDate()).format('HH:mm A');
      }

      // If teeTime is already a Date or valid date string
      if (dayjs(teeTime).isValid()) {
        return dayjs(teeTime).format('hh:mm A');
      }

      return 'Invalid time';
    } catch (error) {
      console.error('Error formatting tee time:', error);
      return 'Invalid time';
    }
  };

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        background: '#fff',
        border: '1px solid #000000',
        borderRadius: '100px',
        p: '8px 8px',
        height: '34px',
        width: '150px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', height: '24px' }}>
        <svg
          width="19"
          height="25"
          viewBox="0 0 19 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2104_3797)">
            <mask
              id="mask0_2104_3797"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="19"
              height="25"
            >
              <path d="M18.1309 0.5H0.130859V24.5H18.1309V0.5Z" fill="white" />
            </mask>
            <g mask="url(#mask0_2104_3797)">
              <path
                d="M8.61423 5.36257C8.61423 4.16709 7.63034 3.19653 6.41844 3.19653C5.20655 3.19653 4.22266 4.16709 4.22266 5.36257C4.22266 6.55805 5.20655 7.52861 6.41844 7.52861C7.63034 7.52861 8.61423 6.55805 8.61423 5.36257Z"
                fill="#112C10"
              />
              <path
                d="M9.3504 2.86895C9.3504 2.86895 11.0505 4.29179 9.62798 5.89554C8.20542 7.49929 6.86465 8.66298 6.82252 9.4233C6.78287 10.1861 7.83863 10.6261 8.77296 11.3473C9.70728 12.0685 11.4966 14.7162 10.3169 17.9628C9.13727 21.2118 5.76428 21.691 5.76428 21.691L6.86218 24.4976C6.86218 24.4976 10.2352 23.4561 12.1063 20.6471C13.9774 17.8405 13.4471 14.633 13.4471 14.633C13.4471 14.633 14.83 16.557 15.115 19.525C15.4 22.4929 15.3182 23.2141 15.3182 23.2141H18.1236C18.1236 23.2141 18.3269 17.1193 16.2946 13.5109C14.2624 9.90247 11.0505 8.65809 11.0505 8.65809C11.0505 8.65809 13.1645 6.17179 12.9217 4.08643C12.6788 2.00107 10.7283 0.5 10.7283 0.5C10.7283 0.5 0.381383 10.5259 0.230206 10.6897C0.0765503 10.8559 0.123638 11.1713 0.230206 11.3057C0.336773 11.4402 0.748174 11.8925 0.976179 12.0881C1.20418 12.2836 1.89068 12.0441 1.7395 11.4426C1.58832 10.8412 1.20666 10.6897 1.60319 10.3303C1.99972 9.96847 9.35288 2.86895 9.35288 2.86895"
                fill="#112C10"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_2104_3797">
              <rect width="18" height="24" fill="white" transform="translate(0.130859 0.5)" />
            </clipPath>
          </defs>
        </svg>
      </Box>
      <Typography variant="body1" sx={{ fontWeight: 700 }}>
        {getFormattedTime()}
      </Typography>
    </Box>
  );
};

export default GameTeeTime;
